/**
 * Created by Mark on 24/04/2017.
 */


import React from "react";
import { FormattedMessage } from 'react-intl';
import {Row , Col , Table} from 'react-bootstrap';
import HomeworkWidget from '../../../homework.js'
import { Link } from 'react-router'
class AboutPanel extends React.Component {

    constructor(props){
        super();
        this.state = {
            assignment:props.data.assignment,
        }

    }

    componentWillReceiveProps(props){

        console.log(props);
        this.setState({assignment:props.data.assignment})
    }

    renderTableBody(){

        if(!this.state.assignment) return null;

        var body = [];

        for(var idx = 0 ; idx < this.state.assignment.students.length; idx++)
        {
            var student = this.state.assignment.students[idx];
            var classes = student.classes.map(function(_class){
                return <li>{_class.getName()}</li>
            });

            body.push(<tr>
                        <td><Link to={'student/profile/'+student.uid}>
                            <i className="zmdi zmdi-link p-r-5"></i>{student.getName()}
                        </Link></td>
                        <td>{classes}</td>
                        <td width="20">
                            <center className="checkbox p-0 m-0">
                                <label><input type="checkbox" disabled readonly checked={student.hasCompleted} value={student.hasCompleted} /><i className="input-helper"></i></label>
                            </center>
                        </td>
                      </tr>);
        }

        return body;
    }

    render(){

        if(!this.state.assignment) return null;

        console.log(this.state.assignment);
        return (
            <div>
                <div className="pmb-block">
                    <div className="pmbb-header">
                        <h2><FormattedMessage id={ 'ui-755' } defaultMessage={ 'Assignment Overview' } /></h2>
                    </div>
                    <div className="pmbb-body palette-Branding secondary bg">
                        <HomeworkWidget totalComplete={this.state.assignment.totalComplete} totalIncomplete={this.state.assignment.totalIncomplete}  totalOverdue={this.state.assignment.totalOverdue}  studentTotal={this.state.assignment.totalStudents}/>
                    </div>
                </div>
                <div className="pmb-block">
                    <div className="pmbb-body">
                        <Table condensed striped responsive bordered>
                            <thead>
                                <tr>
                                    <th><FormattedMessage id={ 'ui-14' } defaultMessage={ 'Name' } /></th>
                                    <th><FormattedMessage id={ 'ui-830' } defaultMessage={ 'Classes' } /></th>
                                    <th><FormattedMessage id={ 'ui-772' } defaultMessage={ 'Completed' } /></th>
                                </tr>
                            </thead>
                            <tbody>
                            {this.renderTableBody()}
                            </tbody>
                        </Table>
                    </div>
                </div>
            </div>
        );
    }
}





export default {
    name: <FormattedMessage id={ 'ui-893' } defaultMessage={ 'About' }/>,
    component: AboutPanel
}


// WEBPACK FOOTER //
// ./src/components/profile/profile-tabs/assignment/about-panel.js